import { QueryStatus } from '../../../../../types'
import {OperacionADL} from '../types/types'
import { useEffect, useState } from 'react'
import {HttpADL} from "../api/httpADL";

export const useOperacionADL = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionADL>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpADL.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return { status, operacion }
}
